import { TrainingToolTileProps } from '../interface/interface';
import LoadingButton from './LoadingButton';

export const TrainingToolTile = (props: TrainingToolTileProps) => {
  function fetchStylesByActiveStatus(isActive: boolean) {
    return isActive
      ? 'text-green-700 bg-green-50 ring-green-600/20'
      : 'text-yellow-800 bg-yellow-50 ring-yellow-600/20';
  }

  return (
    <>
      <li
        key={props.resource.resourceId}
        className="flex items-center justify-between gap-x-6 p-5"
      >
        <div className="min-w-0">
          <div className="flex items-center gap-x-3">
            <p className="text-sm font-semibold text-gray-900">
              {props.resource.resourceName}
            </p>

            <p
              className={`whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset
                ${fetchStylesByActiveStatus(props.resource.isActive)}`}
            >
              {props.resource.isActive ? 'Active' : 'Inactive'}
            </p>
          </div>

          <p className="mt-1 text-xs text-gray-500">
            Created by {props.resource.createdBy}
          </p>
        </div>

        <div className="flex items-center">
          <LoadingButton
            key={props.resource.resourceId}
            className="!w-fit !text-sm !font-medium !rounded-md !shadow-sm"
            isLoading={props.activeButtonIndex === props.resource.resourceId}
            buttonText={'View'}
            isDisabled={props.activeButtonIndex === props.resource.resourceId}
            onClick={() => {
              props.handlePreviewFiles(
                props.resource.resourceId,
                props.resource.resourceName,
              );
            }}
          />
        </div>
      </li>
    </>
  );
};
